<template>
  <div>
    <v-row
      dense
    >
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.NMRP"
            outlined
            dense
            :label="$t('training_builder.text_input.no_of_repetitions.title')"
            :placeholder="$t('label.e_g') + ' ' + 10"
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.RSRPDR"
            outlined
            dense
            :label="$t('training_builder.text_input.rest_between_repetitions.title')"
            :placeholder="$t('label.e_g') + ' ' + 10"
            suffix="s"
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-divider class="mb-6" />

    <v-row dense>
      <v-col cols="6">
        <minute-second-input
          :value="dirtySetParams.RSSTDR"
          :label="$t('training_builder.text_input.rest_time_after_set')"
          variable="RSSTDR"
          @input="handleDurationInput"
        />
      </v-col>
      <v-col cols="6">
        <validation-provider v-slot="{ errors }">
          <number-input
            :value="displayedWeight"
            outlined
            dense
            :label="$t('training_builder.text_input.weight.title')"
            :placeholder="$t('label.e_g') + ' ' + 50"
            :suffix="weightSuffix(user.organisation_settings.unit_system)"
            :decimal-precision="1"
            :error-messages="errors"
            @input="displayedWeight = $event"
          />
        </validation-provider>
      </v-col>
    </v-row>

    <v-divider class="mb-6" />

    <v-row dense>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.NUMGC"
            outlined
            dense
            :label="$t('training_builder.text_input.no_of_ground_contacts.title')"
            :placeholder="$t('label.e_g') + ' ' + 2"
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
      <v-col>
        <validation-provider
          v-slot="{ errors }"
        >
          <number-input
            v-model="dirtySetParams.NOTHR"
            outlined
            dense
            :label="$t('training_builder.text_input.no_of_throws')"
            :placeholder="$t('label.e_g') + ' ' + 5"
            :decimal-precision="0"
            :error-messages="errors"
          />
        </validation-provider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NumberInput from '@/components/helpers/NumberInput.vue'
import { cloneVariables, convertWeightByTimezone, weightSuffix } from '@/components/training-builder/helpers'
import MinuteSecondInput from '@/components/helpers/MinuteSecondInput.vue'
import { cloneDeep } from 'lodash'

export default {
  name: 'BallisticsParamsEntry',
  components: { MinuteSecondInput, NumberInput },
  props: {
    exercise: {
      type: Object,
      required: true
    },
    setParams: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dirtySetParams: cloneVariables(this.setParams),
      internalWeightInKg: null
    }
  },
  computed: {
    user() {
      return this.$store.getters[this.$storeGetters.AUTH_USER]
    },
    displayedWeight: {
      get() {
        return convertWeightByTimezone(this.internalWeightInKg, this.user.organisation_settings.unit_system, true)
      },
      set(value) {
        this.dirtySetParams.WGHT = convertWeightByTimezone(value, this.user.organisation_settings.unit_system, false)
      }
    }
  },
  watch: {
    dirtySetParams: {
      deep: true,
      handler: function (newValue) {
        this.$emit('update:setParams', newValue)
      }
    }
  },
  created() {
    this.internalWeightInKg = cloneDeep(this.dirtySetParams.WGHT)
  },
  methods: {
    weightSuffix,
    checkIfParamExists(param) {
      if (!this.exercise.tags) return false

      return this.exercise.tags.some(t => t.tag_id === 'params' && t.value === param)
    },
    handleDurationInput(min, sec, variable) {
      this.dirtySetParams[variable] = min * 60 + sec > 0 ? min * 60 + sec : null
    }
  }
}
</script>
